import { createApp } from 'vue';
import AacToOpusConverter from '@/Components/AacToOpusConverter.vue';
import '@styles/app.css';

createApp(AacToOpusConverter).mount('#aac-to-opus-converter');
